<template>
    <div class="container d-flex justify-content-center flex-column align-items-center">
        <div class="login-box-event">
            <div class="login-box-left"></div>
            <div class="login-box-right"></div>
            <div class="login-body">
                <h3 class="login-title">{{ $t('login') }}</h3>
                <form method="POST" encType="multipart/form-data" @submit.prevent="onSubmit">
                    <div class="form-group w-100">
                        <input type="text" class="ito-input" :class="{ 'has-err': error.field_username }" name="username"
                            :placeholder="$t('id_email_phone_number')" autocomplete="off" v-model="user.username" />
                        <div class="error-message text-start" v-if="error.field_username">{{ error.field_username }}</div>
                    </div>

                    <div class="form-group position-relative w-100">
                        <input :type="showPass ? 'text' : 'password'" class="ito-input " id="login-password-field"
                            name="password" :class="{ 'has-err': error.field_password }" :placeholder="$t('password')"
                            v-model="user.password" />
                        <span :class="[showPass ? 'icon-eye eye-show' : 'icon-eye eye-hide']"
                            @click="showPass = !showPass"></span>
                        <div class="error-message text-start" v-if="error.field_password">{{ error.field_password }}</div>
                    </div>

                    <div class="form-group d-flex justify-content-end w-100">
                        <a href="/forgot-password" class="forgot-password">
                            {{ $t('you_ve_forgot_password') }}
                        </a>
                    </div>
                    <div class="form-group w-100">
                        <button type="submit" class="ito-btn ito-btn-lg ito-btn-primary ito-btn-block">{{ $t('login')
                        }}</button>
                        <!-- <a href="/register-anomynous" class="ito-btn ito-btn-lg ito-btn-warning ito-btn-block mt-3">{{
                            $t('free_trial')
                        }}</a> -->
                        <login-google />
                        <div class="error-message text-center" v-if="error.message">{{ error.message }}</div>
                    </div>
                    <div class="links text-center">
                        <span>{{ $t('first_time_on_ito') }}</span>
                        <a href="/register" class="link-underline register-link ms-1">{{ $t('create_an_account') }}</a>
                    </div>
                </form>
            </div>
        </div>

        <div id="app-login-event">
            <div class="app-login-title">{{ $t('download_app_title')}}</div>
            <div class="app-login-desc">{{ $t('download_app') }}</div>
            <div class="app-login-download">
                <div class="app-login-android">
                    <div>
                        <a href="https://play.google.com/store/apps/details?id=ismart.edu.vn.ipro" target="_blank">
                            <img src="/themes/ito/images/qr-android.svg" class="app-login-qr" alt="">
                        </a>
                    </div>
                    <div>
                        <a href="https://play.google.com/store/apps/details?id=ismart.edu.vn.ipro" target="_blank">
                            <img src="/themes/ito/images/download-android.svg" alt="">
                        </a>
                    </div>
                </div>
                <div class="app-login-ios">
                    <div>
                        <a href="https://apps.apple.com/us/app/ismart-pro/id6448867836" target="_blank">
                            <img src="/themes/ito/images/qr-ios.svg" class="app-login-qr" alt="">
                        </a>
                    </div>
                    <div>
                        <a href="https://apps.apple.com/us/app/ismart-pro/id6448867836" target="_blank">
                            <img src="/themes/ito/images/download-ios.svg" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { authLogin } from '../../models/auth'
import axios from "axios";
import { getAvatars, getConfig } from "../../models/profile";
import LoginGoogle from './LoginGoogle.vue';

export default {
    name: "Login",
    components: { LoginGoogle },
    data() {
        return {
            error: {
                message: '',
                field_username: '',
                field_password: ''
            },
            user: {
                username: '',
                password: ''
            },
            showPass: false,
        };
    },

    created() {
        this.fetch();
    },
    computed: {
        setAlert() {
            return this.$store.state.setAlert;
        },
    },

    methods: {
        fetch() {
            localStorage['is_login'] = false;
            localStorage['banner_hidden'] = false;
            localStorage.removeItem('access_token');
            localStorage.removeItem('grade');
            localStorage.removeItem('student');
            localStorage.removeItem('program');

            // this.$store.commit("setLoading", true);
            // axios.all([getConfig()]).then(axios.spread((response) => {
            //     this.$store.commit("setLoading", false);
            //     if (response.data.code != 0) {
            //         this.error.message = this.$i18n.t('error_404');
            //         return;
            //     }
            //     const configs = response.data.results || {};
            //     localStorage.setItem('configs', JSON.stringify(configs));
            //     const localize = configs.localize
            //     localize.forEach(element => {
            //         if (element.lang === 'vi') {
            //             $.getJSON(element.link, function (json) {
            //                 localStorage['vi'] = JSON.stringify(json);
            //             });
            //         } else if (element.lang === 'en') {
            //             $.getJSON(element.link, function (json) {
            //                 localStorage['en'] = JSON.stringify(json);
            //             });
            //         }
            //     });
            // }));
        },

        onSubmit(e) {
            this.resetErrorsValid();
            if (!this.user.username) {
                this.error.field_username = this.$i18n.t('username_cannot_be_empty');
            }

            if (!this.user.password) {
                this.error.field_password = this.$i18n.t('password_cannot_be_empty');
            }

            if (this.error.field_username != '' || this.error.field_password != '') {
                return false;
            }
            else {
                const username = this.user.username;
                const password = this.user.password;
                this.login({ username, password });
                e.preventDefault();
            }
        },

        resetErrorsValid() {
            this.error = {
                message: '',
                field_username: '',
                field_password: ''
            }
        },

        login(user) {
            const that = this;
            that.$store.commit("setLoading", true);
            authLogin(user).then((response) => {
                if (response.data.code != 0) {
                    this.error.message = this.$i18n.t(response.data.error_code);
                    that.$store.commit("setLoading", false);
                    return false;
                }
                that.$store.commit('setAuth', true);
                localStorage.setItem('access_token', response.data.results.access_token);

                const santaFlying = [
                    { transform: "translate(0, 0px)" },
                    { transform: "translate(999px, -360px)" },
                    { opacity: 0 }
                ];
                const santaFlyingTiming = {
                    duration: 1000,
                    iterations: 1,
                };
                const santa = document.querySelector(".login-box-right");
                that.$store.commit("setLoading", false);
                santa.animate(santaFlying, santaFlyingTiming);
                setTimeout(() => {
                    location.href = '/';
                }, santaFlyingTiming.duration / 2);
            }).catch(({ response }) => {
                this.$store.commit('setAuth', false);
                that.$store.commit("setLoading", false);

                that.error.message = this.$i18n.t('has_error');
            });
        },
        // loginWithGoogle() {
        //     alert('Login with Google');
        // }
    }
}
</script>

<style scoped>
.login-box-event {
    width: 591px;
    position: relative;
    background: #fff;
    padding: 20px;
    text-align: center;
    box-shadow: 4px 4px 0 rgba(0, 0, 0, .07), inset 0 4px 0 hsla(0, 0%, 91%, .25);
    border-radius: 8px;
}

.login-box-event .login-box-left {
    position: absolute;
    left: -323px;
    top: 40px;
    content: url('/public/themes/ito/images/background-login-chrismas-left.svg');
}

.login-box-event .login-box-right {
    position: absolute;
    right: -360px;
    top: 0;
    content: url('/public/themes/ito/images/background-login-chrismas-right.svg');
    animation-name: floating;
    animation-duration: 3s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
}

.login-box-event .login-body {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.login-title {
    width: 100%;
    color: #070A28;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
}

form {
    width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0;
}

.ito-input {
    width: 100%;
}

.forgot-password {
    color: #00A3FF;
    text-align: right;
    font-size: 12px;
    font-weight: 400;
    text-decoration-line: underline;
}

.ito-btn {
    display: inline-block;
    margin-bottom: 0;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    border-radius: 4px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    box-shadow: 0px 2px 0px 0px rgba(255, 255, 255, 0.20) inset, 4px 4px 0px 0px rgba(0, 0, 0, 0.07);
}

.ito-btn-lg {
    padding: 8px 30px;
    font-size: 16px;
    line-height: 1.3333333;
    border-radius: 30px;
    font-weight: 700;
}

.ito-btn-block {
    display: block;
    width: 100%;
}

.ito-btn-primary {
    color: #FFF;
    background: linear-gradient(180deg, #45BCFF 0%, #00A3FF 100%);
}

.ito-btn-warning {
    color: #FFF;
    background: #FACC5D;
}

@keyframes floating {
    from {
        transform: translate(0, 0px);
    }

    65% {
        transform: translate(0, 15px);
    }

    to {
        transform: translate(0px, 0px);
    }
}







/* #login-box .form-group {
    position: relative;
    max-width: 300px;
    margin: 10px auto;
} */


#app-login-event {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    color: #FFF;

}

#app-login-event .app-login-title {
    font-size: 20px;
    font-weight: 700;
    text-transform: uppercase;
}

#app-login-event .app-login-desc {
    text-align: center;
    font-size: 12px;
    font-weight: 400;
}

#app-login-event .app-login-download {
    display: flex;
    margin-top: 10px;
    gap: 20px;
}

#app-login-event .app-login-download .app-login-android,
#app-login-event .app-login-download .app-login-ios {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
</style>
